export const headerMenuConfig = [
  {
    name: '首页',
    icon: 'home',
    href: '/union/homePage/overview/list.htm',
    children: [
      {
        name: '联盟推广',
        href: '/pcChoice/index.html'
      },
      {
        name: '橱窗推广',
        href: '/union/member/showcase/window/link.htm'
      },
      {
        name: 'SDK推广',
        href: '/union/member/sdkPromotion/list.htm'
      },
    ]
  },
  {
    name: '结算中心',
    icon: 'money',
    href: '/union/member/accountCenter/withdrawal/list.htm',
    children: [
      {
        name: '结算概况',
        href: '/union/member/accountCenter/withdrawal/list.htm'
      },
    ]
  },
  {
    name: '我的联盟',
    icon: 'me',
    href: '/union/myUnion/account/info.htm',
    children: [
      {
        name: '账户信息',
        href: '/union/myUnion/account/info.htm'
      },
      {
        name: '员工专区',
        href: '/union/myUnion/staffArea/info.htm'
      },
    ]
  },
  {
    name: '合伙人计划',
    icon: 'mechanism',
    href: '/union/myMechanism/info.htm',
    children: [
      {
        name: '合伙人计划',
        href: '/union/myMechanism/info.htm'
      },
      {
        name: '汇总数据',
        href: '/union/myMechanism/summaryData/list.htm'
      },
    ]
  },
]

export const headerMenuConfigEnterprise = [
  {
    name: '首页',
    icon: 'home',
    href: '/union/homePage/overview/list.htm',
    children: [
      {
        name: '联盟推广',
        href: '/pcChoice/index.html'
      },
      {
        name: '橱窗推广',
        href: '/union/member/showcase/window/link.htm'
      },
      {
        name: 'SDK推广',
        href: '/union/member/sdkPromotion/list.htm'
      },
    ]
  },
  {
    name: '结算中心',
    icon: 'money',
    href: '/corporateSettlement/index.html',
    children: [
      {
        name: '订单申诉',
        href: '/union/member/accountCenter/orderAppeal/list.htm'
      },
      // {
      //   name: '开票中心',
      //   href: '/corporateSettlement/index.html#/billInfo'
      // },
      {
        name: '结算概况',
        href: '/corporateSettlement/index.html'
      },
      {
        name: 'CPS结算订单',
        href: '/union/member/accountCenter/settlement/v2/order/list.htm'
      },
      {
        name: '锁粉订单',
        href: '/union/member/accountCenter/settlement/lockFansOrder/list.htm'
      },
    ]
  },
  {
    name: '我的联盟',
    icon: 'me',
    href: '/union/myUnion/account/info.htm',
    children: [
      {
        name: '账户信息',
        href: '/union/myUnion/account/info.htm'
      },
    ]
  },
  {
    name: '合伙人计划',
    icon: 'mechanism',
    href: '/union/myMechanism/info.htm',
    children: [
      {
        name: '合伙人计划',
        href: '/union/myMechanism/info.htm'
      },
      {
        name: '汇总数据',
        href: '/union/myMechanism/summaryData/list.htm'
      },
    ]
  },
]